export type ReportsPaginationReportRow = {
  id: string;
  publisherId: string;
  newspaper: string;
  publicationDate: string;
  status: string | null;
  deadline: number | null;
  timezone: string;
  product: string;
  medium: string;
  filingType: string;
  ordersCount: number;
  totalColumnInches?: number;
  sectionId: string;
  publicationIssueId: string;
};

export enum ReportsPubIssuesTableDeadline {
  AdDeadline = 'ad-deadline',
  PublicationDate = 'publication-date'
}
